// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module__wrapper___N53ol","pc":"style-module__pc___8R8hK","bc":"style-module__bc___z6Pdh"};